export default __webpack_public_path__ + "static/media/emptyCloud.0c2c95f3.svg";